<template>
  <div v-if="$site.location" class="h-full w-screen bg-secondary flex flex-col">
    <a href="#content" class="fixed -left-full z-[5000] p-2 m-6 rounded border-white bg-black text-white focus:left-1/2 focus:-translate-x-1/2">Skip to main content</a>

    <div id="main" class="relative overflow-y-auto overflow-x-hidden flex-grow flex-shrink sm:pt-20">
      <slot />
    </div>
    
    <LayoutElementsMobile />

    <LayoutElementsMenu />
  </div>
</template>

<script setup lang="ts">
const { $site } = useNuxtApp()

const layoutStore = useLayoutStore()

useHead(() => {
  return {
    htmlAttrs: {
      class: 'layout-mobile'
    },
    bodyAttrs: {
      class: 'bg-secondary'
    }
  }
})

interface FlutterEvent extends Event {
  detail?: {
    route?: string
  }
}

const eventListeners: { name: string; listener: EventListener }[] = []

onMounted(() => {
  const routeToListener = (event: FlutterEvent) => {
    const route = event?.detail?.route

    if (route) {
      navigateTo(route)
    }
  }

  const toggleMenuListener = () => {
    layoutStore.menu = !layoutStore.menu
  }

  const refreshListener = () => {
    window?.location?.reload()
  }

  handleFlutterEvent('routeTo', routeToListener)
  handleFlutterEvent('toggleMenu', toggleMenuListener)
  handleFlutterEvent('refresh', refreshListener)

  eventListeners.push(
    { name: 'bookapp-routeTo', listener: routeToListener },
    { name: 'bookapp-toggleMenu', listener: toggleMenuListener },
    { name: 'bookapp-refresh', listener: refreshListener }
  )
})

onBeforeUnmount(() => {
  // Clean up event listeners
  eventListeners.forEach(({ name, listener }) => {
    window?.removeEventListener(name, listener)
  })
})

const handleFlutterEvent = (name: string, callback: EventListener) => {
  return window?.addEventListener(`bookapp-${name}`, callback, false)
}
</script>

<style>
@supports (-webkit-touch-callout: none) {
  .h-screen {
    height: -webkit-fill-available;
  }
}

.slide-left-leave-active {
  transition: 0.2s;
}
.slide-left-enter-active {
  transition: 0.3s;
}
.slide-left-enter {
  transform: translate(20%, 0);
  opacity: 0
}

.slide-left-leave-to {
  transform: translate(-20%, 0);
  opacity: 0
}

.slide-left-enter-to {
  opacity: 1
}

.slide-right-leave-active
{
  transition: 0.2s;
}
.slide-right-enter-active
{
  transition: 0.3s;
}
.slide-right-enter {
  transform: translate(-20%, 0);
  opacity: 0
}

.slide-right-enter, .slide-right-enter-active {
}

.slide-right-leave, .slide-right-leave-active {
}

.slide-right-leave-to {
  transform: translate(20%, 0);
  opacity: 0
}

.slide-right-enter-to {
  opacity: 1
}
</style>
